'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Wrapper that allows the end-user to pass user-defined functions e.g
 *  a required setState function via the newFunction and an optional
 *  event tracker via the wrappedFunction
 *
 * @param newFunction -  required user defined function.
 * @param wrappedFunction - optional user defined function.
 *
 * NB: If the types of the arguments/return-values of the functions passed
 *     to this hook differ, Typescript will try to infer the types of the
 *     arguments/return-values. Therefore, the user might need to specify
 *     the types expected/returned by the function(s) when utilizing this hook.
 *     Example where the newFunction expects a boolean and the wrappedFunction
 *     expects a ChangeEvent:
 *  useWrappedFunction<[React.ChangeEvent<{}>], void>(() => setState(true), onChange);
 *  Alternative Syntax:
 *  useWrappedFunction((_: React.ChangeEvent<{}>) => setState(true),onChange);
 */

var useWrappedFunction = function useWrappedFunction(newFunction, wrappedFunction) {
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    newFunction.apply(void 0, args);
    wrappedFunction === null || wrappedFunction === void 0 || wrappedFunction.apply(void 0, args);
  }, [wrappedFunction, newFunction]);
};

exports.useWrappedFunction = useWrappedFunction;
//# sourceMappingURL=index.js.map
